<template>
	<div class="page-header">
		<!-- <router-link to="/" class="logo fl">
            <img src="@/assets/img/logo.png" />
            <span class="logo-name">秀动管理后台</span> <el-tag size="mini">beta2.0</el-tag>
        </router-link> -->
		<div class="page-header-left">
			<Logo class="logo"></Logo>
			<!-- <el-tag size="mini">beta2.0</el-tag> -->
			<div class="hidden-sm-and-up">
				<div class="menu-btn" @click="drawerShow">
					<i class="el-icon-s-fold"></i>
				</div>
			</div>
		</div>
		<div class="page-header-right">
			<!-- 消息中心 -->
			<!-- BUG-02修复：element-ui 2.15.x 的 ElPopover 无 value prop，v-model 绑定无效导致铃铛/查看全部打不开；
				改为 trigger=manual 下程序调用 doShow()/doClose() 控制显隐，@show/@hide 同步状态镜像 -->
			<el-popover v-if="userInfo" ref="msgPopover" placement="bottom" width="360" trigger="manual"
				@show="onPopoverShow" @hide="onPopoverHide">
				<!-- 消息列表头部 -->
				<div class="msg-header" @click.stop>
					<span class="msg-title">消息中心</span>
					<el-button v-if="unreadCount > 0" type="text" size="mini" @click="readAll">全部已读</el-button>
				</div>
				<!-- 消息列表 -->
				<div class="msg-list">
					<div v-for="item in msgList" :key="item.id" class="msg-item">
						<div class="msg-item-title">{{ item.title }}</div>
						<div class="msg-item-content">{{ item.content }}</div>
						<div class="msg-item-footer">
							<span class="msg-item-time">{{ item.createTime }}</span>
							<el-tag size="mini"
								:type="item.bizStatus === 1 ? 'danger' : item.bizStatus === 2 ? 'success' : 'info'">{{
									item.bizStatusView }}</el-tag>
						</div>
						<!-- 需求7139979129：关联对象直达入口（演出/巡演页面新窗口打开） -->
						<!-- 架构师意见③：改用 vue-router（router-link）跳转，避免裸 <a> 造成整页资源重载 -->
						<div v-if="item.relatedObjects && item.relatedObjects.length" class="msg-item-related">
							<router-link v-for="ro in item.relatedObjects" :key="ro.objectId" class="msg-related-link"
								:to="ro.objectType == 1 ? '/activityManage/activity/edit/baseInfo/' + ro.objectId : '/activityManage/touring/manage/' + ro.objectId"
								target="_blank">[{{ ro.objectTypeDesc }}] {{ ro.objectName }}</router-link>
						</div>
					</div>
					<div v-if="!msgList.length" class="msg-empty">暂无消息</div>
				</div>
				<!-- 消息列表底部 -->
				<div class="msg-footer">
					<span class="msg-tip">读取消息不等于完成待办</span>
					<el-button type="text" size="mini" @click="goToTodo">进入待办管理</el-button>
				</div>
				<!-- 触发按钮 -->
				<el-badge :is-dot="unreadCount > 0" class="msg-badge" slot="reference">
					<i class="el-icon-bell msg-bell" @click="toggleMsgPopover"></i>
				</el-badge>
			</el-popover>
			<el-dropdown v-if="userInfo" @command="handleCommand">
				<span class="el-dropdown-link">
					{{ userInfo.name }}<i class="el-icon-arrow-down el-icon--right"></i>
				</span>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item icon="el-icon-edit-outline" command="editpwd">修改密码</el-dropdown-item>
					<el-dropdown-item icon="el-icon-switch-button" command="logout">退出登录</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
		<el-drawer :visible.sync="drawer" direction="ltr" :with-header="false" size="225px"
			custom-class="menu-drawer hidden-sm-and-up" ref="drawer" append-to-body>
			<el-aside style="width:auto">
				<page-menu :isCollapse="false" :menuWidth="225"></page-menu>
			</el-aside>
		</el-drawer>
		<edit ref="Editpwd"></edit>
	</div>
</template>
<script>
import PageMenu from "./components/menu";
import Logo from './components/logo';
import Edit from "./components/updatepwd";
import { Notification } from 'element-ui';

export default {
	name: "pageHeader",
	components: {
		PageMenu,
		Logo,
		Edit
	},
	data() {
		return {
			drawer: false,
			msgPopVisible: false, // 消息弹窗显隐
			msgList: [], // 消息列表
			unreadCount: 0, // 未读数量
			notify: null, // 消息通知实例
			dismissedMaxMsgId: 0, // 已忽略提醒的最大消息ID（点X/查看全部后不再弹出，直到出现更新的消息）
			msgPollTimer: null, // 消息轮询定时器
		};
	},
	computed: {
		userInfo() {
			const userInfo = this.$store.state.userInfo || null;
			if (userInfo) {
				this.getMsgList(true);
			}
			return userInfo;
		}
	},
	mounted() {
		// 架构师意见②：原 window.onresize 全局覆盖写法改为 addEventListener，销毁时成对移除，不污染全局
		this.handleWindowResize = () => {
			const winWidth = window.innerWidth || document.body.clientWidth;
			if (winWidth >= 768 && this.$refs.drawer) {
				this.$refs.drawer.closeDrawer()
			}
		}
		window.addEventListener('resize', this.handleWindowResize);
		// 点击弹窗外部关闭消息弹窗
		document.addEventListener('click', this.handleDocumentClick);
		// 定时轮询未读消息：待办到提醒时间点后由后端生成消息，前端需轮询才能弹出提醒
		// 需求7139979129：轮询间隔 60s→15s，配合后端 Job 每分钟扫描，提醒最坏延迟约75秒
		// 架构师意见①：页面隐藏期间跳过轮询请求（后台标签页本会被浏览器节流，且切回可见时
		// visibilitychange 会立即拉取一次，无漏报），避免长驻后台空转造成页面假死
		this.msgPollTimer = setInterval(() => {
			if (!document.hidden && this.$store.state.userInfo) {
				this.getMsgList(true);
			}
		}, 15 * 1000);
		// 需求7139979129：浏览器对后台标签页的定时器节流会导致轮询停摆，切回页面瞬间立即拉取一次
		document.addEventListener('visibilitychange', this.handleVisibilityChange);
	},
	beforeDestroy() {
		// 移除窗口尺寸监听（与 mounted 的 addEventListener 成对）
		if (this.handleWindowResize) {
			window.removeEventListener('resize', this.handleWindowResize);
			this.handleWindowResize = null;
		}
		// 移除点击外部监听
		document.removeEventListener('click', this.handleDocumentClick);
		// 清除消息轮询定时器
		if (this.msgPollTimer) {
			clearInterval(this.msgPollTimer);
			this.msgPollTimer = null;
		}
		document.removeEventListener('visibilitychange', this.handleVisibilityChange);
	},

	// 监听,当路由发生变化的时候执行
	watch: {
		$route() {
			this.$refs.drawer.closeDrawer();
		}
	},

	methods: {
		// 页面切回可见时立即拉取未读消息（后台节流会暂停轮询，需求7139979129）
		handleVisibilityChange() {
			if (!document.hidden && this.$store.state.userInfo) {
				this.getMsgList(true);
			}
		},
		drawerShow() {
			this.drawer = true;
		},

		handleCommand(command) {
			// 退出登录
			if (command === 'logout') {

				this.$request({
					url: '/logout',
					method: 'post'
				}).then(res => {
					const {
						state,
						msg
					} = res.data
					if (!state) return this.$message.error(msg);
					this.$store.commit('logOut')
					this.$router.push({
						path: '/login'
					})
				})
			}
			//
			if (command === 'editpwd') {
				this.$refs.Editpwd.show();
			}
		},
		// 切换消息弹窗显隐（BUG-02修复：popover 无 value prop，须调组件方法控制）
			toggleMsgPopover() {
				const ref = this.$refs.msgPopover;
				if (!ref) return;
				if (this.msgPopVisible) {
					ref.doClose();
				} else {
					ref.doShow();
				}
			},
			// popover 显示/隐藏事件同步状态镜像（原 v-model 无效，改由事件回写）
			onPopoverShow() {
				this.msgPopVisible = true;
				this.getMsgList();
			},
			onPopoverHide() {
				this.msgPopVisible = false;
			},
			// 点击弹窗外部关闭
			handleDocumentClick(e) {
				if (!this.msgPopVisible) return;
				// 打开面板的同一Click事件不判定为外部点击（如通知里「查看全部」按钮：
				// doShow 后该次点击继续冒泡到 document，若不跳过会立刻把面板关回去）
				if (e === this._msgPopOpenEvt) return;
				const ref = this.$refs.msgPopover;
				if (!ref) return;
				const popoverEl = ref.$el || ref.$refs.popper;
				if (popoverEl && !popoverEl.contains(e.target)) {
					// 确保不是点击触发按钮
					const bellEl = this.$el.querySelector('.msg-bell');
					if (bellEl && !bellEl.contains(e.target)) {
						ref.doClose();
					}
				}
			},
			// 获取消息列表
		async getMsgList(onlyUnread = false) {
			try {
				const res = await this.$request({
					url: '/messageCenter/listResult',
					method: 'post',
					data: {
						onlyUnread
					}
				});
				const { state, result } = res.data;
				if (state == 1 && result) {
					this.msgList = result.list || [];
					this.unreadCount = result.unreadCount || 0;
					// 仅在未读模式下、未展示过通知且popover未打开时，弹出未读消息列表通知（已忽略过的旧消息不再弹出）
					const unreadIds = this.msgList.filter(item => !item.isRead).map(item => item.id);
					const maxUnreadId = unreadIds.length ? Math.max(...unreadIds) : 0;
					if (this.unreadCount > 0 && !this.notify && !this.msgPopVisible && maxUnreadId > this.dismissedMaxMsgId) {
						Notification.closeAll();
						this.showMsgNotification();
					}
				}
				this.$nextTick(() => {
					this.popoverTriggerType = 'click';
				});
			} catch (err) {
				// 静默处理
			}
		},
		// 展示未读消息通知（需求7139979129：多消息列表展示，最新在前，可滚动查看）
		showMsgNotification() {
			// 防双弹护栏：已有通知实例时直接返回（本地实测页面加载瞬间偶发弹出两条相同通知，
			// getMsgList 的 !this.notify 检查在并发/组件重建场景下存在空窗，此处兜底）
			if (this.notify) return;
			// 需求7139979129：排除后端虚拟的营销短信审核消息（id=0 不可已读、生成时间恒为当前会打乱最新在前排序）
			const unreadMsgs = this.msgList.filter(item => !item.isRead && item.bizType !== 'sms_audit').slice(0, 10);
			if (!unreadMsgs.length) return;
			let isClosed = false;
			const h = this.$createElement;
			const shownMaxId = Math.max(...unreadMsgs.map(msg => msg.id));
			// 关闭通知（任何关闭方式都记录已展示的最大消息ID，防止轮询反复弹出）
			const closeNotify = () => {
				if (isClosed) return;
				isClosed = true;
				this.dismissedMaxMsgId = shownMaxId;
				if (this.notify) {
					this.notify.close();
					this.notify = null;
				}
			};
			// 标记单条已读
			const markAsRead = (messageId) => {
				return this.$request({
					url: '/messageCenter/markAsRead',
					method: 'post',
					data: { messageId },
				});
			};
			// 全部已读并关闭通知
			const markAllReadAndClose = () => {
				closeNotify();
				this.$request({
					url: '/messageCenter/markAllAsRead',
					method: 'post',
				}).then(() => {
					this.unreadCount = 0;
				}).catch(() => {});
			};
			// 点击单条消息：标记已读、关闭通知、跳转待办管理
			const handleItemClick = (msg) => {
				closeNotify();
				markAsRead(msg.id).catch(() => {});
				this.unreadCount = Math.max(0, this.unreadCount - 1);
				if (msg.bizType === 'pending_task') {
					this.$router.push({ path: '/workbench/work' });
				}
			};
			// 查看全部：打开消息中心弹窗并刷新列表（BUG-02修复：调 popover doShow）
			const handleViewAll = (e) => {
				closeNotify();
				// 记录本次点击事件：popover 打开后，同一次点击冒泡到 document 时
				// 不应被 handleDocumentClick 判定为「点击外部」而立即关闭（否则面板打不开）
				this._msgPopOpenEvt = e;
				this.$refs.msgPopover && this.$refs.msgPopover.doShow();
				this.getMsgList();
			};
			this.notify = this.$notify({
				title: `消息提醒（共${this.unreadCount}条未读）`,
				dangerouslyUseHTMLString: true,
				message: h('div', [
					// 消息列表：最新在前，超出高度滚动查看
					h('div', {
						style: { maxHeight: '260px', overflowY: 'auto' }
					}, unreadMsgs.map(msg => h('div', {
						style: { padding: '6px 4px', borderBottom: '1px solid #EBEEF5', cursor: 'pointer' },
						on: { click: () => handleItemClick(msg) }
					}, [
						h('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '4px' } }, [
							h('span', { style: { color: '#303133', fontSize: '13px', fontWeight: 'bold' } }, msg.title || ''),
							h('el-tag', {
								props: {
									size: 'mini',
									type: msg.bizStatus === 1 ? 'danger' : msg.bizStatus === 2 ? 'success' : 'info'
								},
								style: { flexShrink: '0' }
							}, msg.bizStatusView || ''),
						]),
						h('div', { style: { color: '#909399', fontSize: '12px', marginBottom: '2px' } }, msg.content || ''),
						h('div', { style: { color: '#C0C4CC', fontSize: '12px' } }, msg.createTime || ''),
						// 需求7139979129：关联对象直达入口（演出/巡演页面新窗口打开，点击不触发整条已读跳转）
						// 架构师意见③：h('a') 裸超链接改 h('router-link')，走 vue-router 跳转
						h('div', { style: { marginTop: '4px' } }, (msg.relatedObjects || []).map(ro => h('router-link', {
							props: {
								to: ro.objectType == 1 ? '/activityManage/activity/edit/baseInfo/' + ro.objectId : '/activityManage/touring/manage/' + ro.objectId
							},
							attrs: { target: '_blank' },
							style: { color: '#409EFF', fontSize: '12px', marginRight: '10px' },
							on: { click: (e) => e.stopPropagation() }
						}, '[' + (ro.objectTypeDesc || '') + '] ' + (ro.objectName || '')))),
					]))),
					h('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '8px' } }, [
						h('el-button', { props: { type: 'text', size: 'small' }, style: { padding: '0' }, on: { click: handleViewAll } }, '查看全部'),
						h('el-button', { props: { type: 'text', size: 'small' }, style: { padding: '0' }, on: { click: markAllReadAndClose } }, '全部已读并关闭'),
					]),
				]),
				duration: 0,
				position: 'bottom-right',
				customClass: 'msg-notification',
				onClose: () => {
					if (isClosed) return;
					isClosed = true;
					this.notify = null;
					// 点X仅忽略本轮提醒，不标记已读，未读数保留给消息中心查看
					this.dismissedMaxMsgId = shownMaxId;
				},
			});
		},
		// 全部已读
		async readAll() {
			try {
				const res = await this.$request({
					url: '/messageCenter/markAllAsRead',
					method: 'post',
				});
				const { state, msg } = res.data;
				if (state == 1) {
					this.$message.success('已全部标记为已读');
					this.unreadCount = 0;
					// this.getMsgList();
				} else {
					this.$message.error(msg || '操作失败');
				}
			} catch (err) {
				this.$message.error('操作失败');
			}
		},
		// 进入待办管理
		goToTodo() {
			this.$refs.msgPopover && this.$refs.msgPopover.doClose();
			this.$router.push({ path: '/workbench/work' });
		},
	}
};
</script>
<style lang="scss" scoped>
.page-header {
	background: #212121;
	height: 42px;
	line-height: 42px;
	padding: 0 20px;
	display: flex;
	align-items: center;
	justify-content: space-between;

	.page-header-left {
		display: flex;
		align-items: center;

		.logo {
			margin-left: 54px;
		}

		.menu-btn {
			display: flex;
			align-items: center;
			justify-content: center;
			border: 1px #666666 solid;
			color: #909399;
			text-align: center;
			width: 30px;
			height: 30px;
			line-height: 30px;

			i {
				font-size: 20px;
			}
		}
	}

	.page-header-right {
		display: flex;
		align-items: center;
		gap: 15px;

		// 消息铃铛
		.msg-badge {
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;

			.msg-bell {
				color: #ffffff;
				font-size: 18px;
			}
		}

		// 下拉菜单
		.el-dropdown {
			.el-dropdown-link {
				color: #ffffff;
			}
		}
	}

	::v-deep.menu-drawer {
		background: #3d3d3d;

		.el-aside {
			height: 100vh;
		}
	}
}



// 消息弹窗头部
.msg-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-bottom: 10px;
	border-bottom: 1px solid #ebeef5;

	.msg-title {
		font-weight: bold;
		font-size: 14px;
	}
}

// 消息列表
.msg-list {
	max-height: 400px;
	overflow-y: auto;

	// 消息项
	.msg-item {
		padding: 10px 0;
		border-bottom: 1px solid #f0f0f0;

		&:last-child {
			border-bottom: none;
		}

		// 消息标题
		.msg-item-title {
			font-size: 13px;
			font-weight: bold;
			color: #303133;
			margin-bottom: 4px;
		}

		// 消息内容
		.msg-item-content {
			font-size: 12px;
			color: #909399;
			margin-bottom: 4px;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 3;
			-webkit-box-orient: vertical;
		}

		// 消息底部信息
		.msg-item-footer {
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: 11px;
			color: #c0c4cc;
		}

		// 需求7139979129：关联对象直达链接
		.msg-item-related {
			margin-top: 4px;

			.msg-related-link {
				color: #409EFF;
				font-size: 12px;
				margin-right: 10px;

				&:hover {
					opacity: 0.8;
				}
			}
		}
	}

	// 空状态
	.msg-empty {
		text-align: center;
		padding: 30px 0;
		color: #909399;
		font-size: 13px;
	}
}

// 消息弹窗底部
.msg-footer {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-top: 10px;
	border-top: 1px solid #ebeef5;

	.msg-tip {
		font-size: 12px;
		color: #909399;
	}
}


@media screen and (max-width: 768px) {
	.page-header {
		padding: 0 10px;

		.page-header-left {
			.logo {
				margin-left: 0;
			}
		}
	}
}
</style>
<style lang="scss">
.msg-notification .el-notification__group {
	width: 100%;
}
</style>